<template>
    <div class="d-inline" v-if="despesa">
        <span class="text-success ml-1" v-if="mostrarIconeFinanceiro">
            <i
                class="fa fa-check-circle fa-lg"
                title="Processo Recebido/Quitado"
            ></i>
        </span>
        <app-status
            class="text-success ml-1"
            :status="statusLabel"
            v-if="mostrarStatus"
        ></app-status>
        <app-status
            class="text-success ml-1"
            status="COMPRAS"
            v-if="mostrarCompra"
        ></app-status>
    </div>
</template>

<script>
import { StatusComprometimento } from './StatusComprometimento'

export default {
    props: {
        despesa: Object
    },

    data() {
        return {}
    },

    computed: {
        mostrarIconeFinanceiro() {
            return (
                this.despesa &&
                (this.despesa.statusIdFat == 'F' || this.despesa.statusIdFat == 'Q')
            )
        },

        mostrarStatus() {
            return (
                this.despesa.statusComprometimentoId !==
                StatusComprometimento.COMPROMETIDO
            )
        },

        mostrarCompra() {
            return this.despesa.movimentoCompra
        },

        statusLabel() {
            switch (this.despesa.statusComprometimentoId) {
                case StatusComprometimento.NAO_COMPROMETIDO:
                    return 'NÃO COMPROMETIDO'
                case StatusComprometimento.ERRO:
                    return 'ERRO'
                case StatusComprometimento.COMPROMETIMENTO_EXCLUIDO:
                    return 'EXCLUÍDO'
                case StatusComprometimento.ATUALIZAR_COMPROMETIMENTO:
                    return 'EM ATUALIZAÇÃO'
                default:
                    return ''
            }
        }
    }
}
</script>
